<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('courses.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_course') && !isProfileTabCourse"
                :title="$addLabel('course')"
                @click="openCourseModal()"
            />
        </app-page-top-section>

        <app-table
            id="course-table"
            :options="options"
            @action="triggerActions"
        />

        <app-course-modal
            v-if="isCourseModalActive"
            v-model="isCourseModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('course-table')"
            @cancelled="cancelled"
        />

    </div>
</template>

<script>
import CourseMixin from "../../../Mixins/Learning/CourseMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {COURSE_LESSON_WEB, COURSEWEB, LESSON_VIEW} from "../../../../Config/ApiUrl";

export default {
    name: "Courses",
    mixins: [CourseMixin],
    props: {
        props: {
            default: ''
        },
        employeeId: {
            type: String,
        },
    },
    data() {
        return {
            course: '',
            coursesId: '',
            courses: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            title: '',
            description: '',
            passing_score: '',
            isProfileTabCourse: false,
            isCourseModalActive: false,
            isEmployeeMovementModalActive: false,
        }
    },
    created() {
        const path = window.location.pathname;
        const parts = path.split('/');

        // Check if it's the employee profile page
        if (parts[1] === 'employees' && parts[3] === 'profile') {
            this.empId = parts[2]; // "5"
        }

        const queryParams = new URLSearchParams(window.location.search);
        this.isProfileTabCourse = queryParams.get('tab') === 'Course';

        // If it's employee profile with tab=Course, apply filter to show only their courses
        if (this.empId && this.isProfileTabCourse) {
            this.options.url = `${COURSE}?employee_id=${this.empId}`;
            this.options.showAction = false; // Hide dropdown if needed
        }
        this.$store.dispatch('course')
    },
    watch: {
        isCourseModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openCourseModal() {
            this.selectedUrl = '';
            this.isCourseModalActive = true;
        },
        triggerActions(row, action, active) {
            this.coursesId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'start_lesson') {
                window.location.href = urlGenerator(`${COURSE_LESSON_WEB}/${row.id}`); // Redirect to the generated URL
            }
            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isCourseModalActive = true;
            } else if (action.key === 'view_details') {
                window.location = urlGenerator(`${COURSEWEB}/${row.id}`)
            }
            else {
                this.getAction(row, action, active)
            }
        },
    }
}
</script>
